import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './main.module.scss';

class MainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    const cssClass = [styles.main, ...this.props.className];
    return (
      <main className={cssClass.join(' ')}>
        {this.props.children}
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return { }
};

const mapDispatchToProps = (dispatch) => {
  return { }
}

const Main = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainContainer);

Main.defaultProps = { };

Main.propTypes = { };

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/index.jsx